import styled from "@emotion/styled";

export const Section = styled.section`
  display: flex;
  width: 100%;
  max-width: 1280px;
  align-self: center;
  justify-self: center;
  padding: 0 128px;
`;
